/**
 * Rock Off Retail — mobile menu drawer (item 6).
 *
 * Plain slide-in panel: the hamburger button (data-mobile-menu-open) opens
 * it, the overlay/close button (data-mobile-menu-close) or Escape closes
 * it. Body scroll is locked while open. No dependency on Dawn's own
 * <menu-drawer> component (this header is a standalone section, see the
 * comment at the top of sections/rockoff-header.liquid) — small enough to
 * be its own custom element.
 */
class RockoffMobileMenu extends HTMLElement {
  connectedCallback() {
    this.openBtn = document.querySelector('[data-mobile-menu-open]');
    this.closeEls = this.querySelectorAll('[data-mobile-menu-close]');

    if (this.openBtn) {
      this.openBtn.addEventListener('click', () => this.open());
    }
    this.closeEls.forEach((el) => el.addEventListener('click', () => this.close()));

    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.close();
    });
  }

  open() {
    this.classList.add('is-open');
    document.documentElement.classList.add('ro-mobile-menu-lock');
    if (this.openBtn) this.openBtn.setAttribute('aria-expanded', 'true');
    const closeBtn = this.querySelector('.ro-mobile-menu__close');
    if (closeBtn) closeBtn.focus();
  }

  close() {
    this.classList.remove('is-open');
    document.documentElement.classList.remove('ro-mobile-menu-lock');
    if (this.openBtn) {
      this.openBtn.setAttribute('aria-expanded', 'false');
      this.openBtn.focus();
    }
  }
}

customElements.define('rockoff-mobile-menu', RockoffMobileMenu);
